var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticClass:"stats-button",attrs:{"theme":"secondary","label":_vm.label},on:{"click":function($event){return _vm.scrollToAnchor(_vm.hash)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }